module.exports = __webpack_public_path__ + "media/images/shinagawa-lasik-logo-0ae7901acaf5d9bb221664e344edca8c.webp";